import { atom, selector } from 'recoil'
import Decimal from 'decimal.js'

function generateFeeProgramInfo(feeProgramInfoList) {
  let maxTier = 1
  const map = {}
  feeProgramInfoList.forEach(data => {
    data.maker_fee = data.maker_fee.replace('%', '')
    data.taker_fee = data.taker_fee.replace('%', '')
    map[data.tier] = data
    maxTier = Math.max(maxTier, Number(data.tier))
  })
  return { maxTier, map }
}

export const accountInfoState = atom({
  key: 'AccountInfo',
  default: {}
  /*
    {
      "account_id": "jolly.near",
      "email": "test@test.com",
      "account_mode":"SPOT_FUTURES", //account mode
      "tier": "1",
      "taker_fee_rate": 10.0,
      "maker_fee_rate": 10.0,
      "futures_taker_fee_rate": 4,
      "futures_maker_fee_rate": 4,
      "max_leverage": 5,
      "maintenance_cancel_orders": true,
      "imr_factor": {
        "BTC": 2.512e-7,
        "WOO": 0.0000058045,
        "ETH": 3.003e-7,
        "NEAR": 0.0000048045
      }
    }
  */
})

export const _accountTradingVolumeInfoState = atom({
  key: '_AccountTradingInfoVolume',
  default: {}
})

export const accountTradingVolumeInfoState = selector({
  key: 'AccountTradingInfoVolume',
  get: ({ get }) => get(_accountTradingVolumeInfoState),
  set: ({ set }, data) => {
    const {
      days_since_registration = 0,
      fees_paid_last_30_days = 0,
      trading_volume_last_24_hours = 0,
      trading_volume_last_30_days = 0,
      trading_volume_ytd = 0,
      perp_fees_paid_last_30_days = 0,
      perp_trading_volume_last_24_hours = 0,
      perp_trading_volume_last_30_days = 0,
      perp_trading_volume_ytd = 0
    } = data
    set(_accountTradingVolumeInfoState, {
      days_since_registration,
      ALL: {
        '24_HOURS': Decimal(trading_volume_last_24_hours)
          .add(perp_trading_volume_last_24_hours)
          .toNumber(),
        '30_DAYS': Decimal(trading_volume_last_30_days)
          .add(perp_trading_volume_last_30_days)
          .toNumber(),
        YTD: Decimal(trading_volume_ytd).add(perp_trading_volume_ytd).toNumber()
      },
      SPOT: {
        '24_HOURS': trading_volume_last_24_hours,
        '30_DAYS': trading_volume_last_30_days,
        YTD: trading_volume_ytd,
        '30_DAYS_FEES_PAID': fees_paid_last_30_days
      },
      FUTURES: {
        '24_HOURS': perp_trading_volume_last_24_hours,
        '30_DAYS': perp_trading_volume_last_30_days,
        YTD: perp_trading_volume_ytd,
        '30_DAYS_FEES_PAID': perp_fees_paid_last_30_days
      }
    })
  }
})

export const feeProgramMaxTierState = atom({
  key: 'FeeProgramMaxTier',
  default: 6
})

export const _feeProgramInfoMapState = atom({
  key: '_FeeProgramInfoMap',
  default: {}
})

export const feeProgramInfoMapState = selector({
  key: 'FeeProgramInfoMap',
  get: ({ get }) => get(_feeProgramInfoMapState),
  set: ({ set }, feeProgramInfoList) => {
    const { maxTier, map } = generateFeeProgramInfo(feeProgramInfoList)
    set(_feeProgramInfoMapState, map)
    set(feeProgramMaxTierState, maxTier)
  },
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const futuresFeeProgramMaxTierState = atom({
  key: 'FuturesFeeProgramMaxTier',
  default: 6
})

export const _futuresFeeProgramInfoMapState = atom({
  key: '_FuturesFeeProgramInfoMap',
  default: {}
})

export const futuresFeeProgramInfoMapState = selector({
  key: 'FuturesFeeProgramInfoMap',
  get: ({ get }) => get(_futuresFeeProgramInfoMapState),
  set: ({ set }, feeProgramInfoList) => {
    const { maxTier, map } = generateFeeProgramInfo(feeProgramInfoList)
    set(_futuresFeeProgramInfoMapState, map)
    set(futuresFeeProgramMaxTierState, maxTier)
  },
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const showAdjustLeveragePopupState = atom({
  key: 'ShowAdjustLeveragePopup',
  default: false
})
